// 'use client';
// import React from 'react';
// import Link from 'next/link';
// import ProductCard from '@/features/product-card/components/productCard';
// import { Product } from '../types/type';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Autoplay } from 'swiper/modules';
// import 'swiper/css';

// const BestSellingProducts = ({ products }: any) => {
//   return (
//     <section className="popular-product padding-bottom">
//       <div className="container">
//         <div
//           className="popular-product__wrapper"
//           data-aos="fade-up"
//           data-aos-duration="1000"
//         >
//           <div className="section-header">
//             <h2 className="section-title mb-2 mb-sm-0">
//               Best Selling Products
//             </h2>
//             <Link href="/hot-deals" className="trk-btn d-none d-sm-block">
//               View all
//             </Link>
//           </div>
//           {products?.length > 0 ? (
//             <Swiper
//               spaceBetween={12}
//               loop={true}
//               modules={[Autoplay]}
//               slidesPerView={2}
//               autoplay={{
//                 delay: 3000,
//                 disableOnInteraction: false,
//                 pauseOnMouseEnter: true,
//               }}
//               breakpoints={{
//                 480: { slidesPerView: 2.25 },
//                 768: { slidesPerView: 3.25 },
//                 992: { slidesPerView: 4.25, spaceBetween: 24 },
//                 1200: { slidesPerView: 5 },
//               }}
//             >
//               {products.map((product: Product, index: number) => (
//                 <SwiperSlide key={index}>
//                   <div className="py-1">
//                     <ProductCard data={product} />
//                   </div>
//                 </SwiperSlide>
//               ))}
//             </Swiper>
//           ) : (
//             <p className="text-center">No products available.</p>
//           )}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default BestSellingProducts;

// src/features/Best-Selling-Products/components/BestSellingProducts.tsx

// NO 'use client' anymore. This is now a Server Component.
'use client';
import Link from 'next/link';
import { fetcher } from '@/lib/fetcher';
import { BestSellingSlider } from './BestSellingSlider'; // Import the new client component
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { ProductCardCarouselSkeleton } from './ProductCardCarouselSkeleton';

// This component is now ASYNC and fetches its own data
const BestSellingProducts = () => {
  // const homeThings = await fetcher('/api/v2/home-things?for=desktop');
  const { data: homeThings, isLoading } = useFetcherCSR(
    `/api/v2/home-things?for=desktop`
  );
  const products = homeThings?.bestselling_products ?? [];
  if (isLoading) return <ProductCardCarouselSkeleton />;

  // If there are no products, we render nothing.
  if (products.length === 0) {
    return null;
  }

  return (
    <section className="popular-product  padding-bottom ">
      <div className="container">
        {/* ✅ REMOVED the data-aos wrapper for better performance */}
        <div className="popular-product__wrapper">
          {/* This header is now static HTML rendered on the server */}
          <div className="section-header">
            <h2 className="section-title mb-2 mb-sm-0">
              Best Selling Products
            </h2>
            <Link href="/products" className="trk-btn d-none d-sm-block">
              View all
            </Link>
          </div>
          {/* We pass the server-fetched data down to our client component */}
          <BestSellingSlider products={products} />
        </div>
      </div>
    </section>
  );
};

export default BestSellingProducts;
